import React from "react";

const TestContext = React.createContext(null);

export default TestContext;